/**
 * Shared operational status colours and badges for Progress/map views.
 */

import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { TrackerOperationalStatus } from '@shared/tracker-types';
import {
  OPERATIONAL_STATUS_COLORS,
  REJECTION_INDICATOR_COLOR,
} from '@shared/tracker-operational-status';

export function getOperationalPinColor(status: TrackerOperationalStatus): string {
  return OPERATIONAL_STATUS_COLORS[status];
}

export function getOperationalPinStroke(
  status: TrackerOperationalStatus,
  rejectedCount = 0,
  selected = false,
): { color: string; weight: number } {
  if (rejectedCount > 0) {
    return { color: REJECTION_INDICATOR_COLOR, weight: selected ? 4 : 3 };
  }
  return { color: selected ? '#000' : '#fff', weight: selected ? 3 : 2 };
}

export function OperationalStatusBadge({
  status,
}: {
  status: TrackerOperationalStatus;
  rejectedCount?: number;
}) {
  switch (status) {
    case 'NOT_STARTED':
      return <Badge variant="outline" className="text-gray-600 border-gray-300">Not started</Badge>;
    case 'IN_PROGRESS':
      return <Badge className="bg-blue-500 hover:bg-blue-600">In progress</Badge>;
    case 'COMPLETE':
      return <Badge variant="secondary" className="bg-green-100 text-green-700">Operator complete</Badge>;
    default: {
      const exhaustive: never = status;
      return exhaustive;
    }
  }
}

export function RejectionIndicator({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <Badge variant="outline" className="text-orange-700 border-orange-300 bg-orange-50 text-xs">
      {count} rejection{count === 1 ? '' : 's'}
    </Badge>
  );
}
